import Vue from 'vue'
import Vuex from 'vuex'
import product from './modules/product'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    cart: [],
    currency: 'USD',
    language: 'zh',
    user: null
  },
  mutations: {
    addToCart(state, product) {
      const existingItem = state.cart.find(item => item.id === product.id)
      if (existingItem) {
        existingItem.quantity += 1
      } else {
        state.cart.push({
          ...product,
          quantity: 1
        })
      }
      localStorage.setItem('cart', JSON.stringify(state.cart))
    },
    removeFromCart(state, productId) {
      state.cart = state.cart.filter(item => item.id !== productId)
      localStorage.setItem('cart', JSON.stringify(state.cart))
    },
    updateCartItemQuantity(state, { id, quantity }) {
      const item = state.cart.find(item => item.id === id)
      if (item) {
        item.quantity = quantity
        localStorage.setItem('cart', JSON.stringify(state.cart))
      }
    },
    clearCart(state) {
      state.cart = []
      localStorage.removeItem('cart')
    },
    setCurrency(state, currency) {
      state.currency = currency
      localStorage.setItem('currency', currency)
    },
    setLanguage(state, language) {
      state.language = language
      localStorage.setItem('language', language)
    },
    setUser(state, user) {
      state.user = user
      if (user) {
        localStorage.setItem('user', JSON.stringify(user))
      } else {
        localStorage.removeItem('user')
      }
    },
    initializeStore(state) {
      const cart = localStorage.getItem('cart')
      const currency = localStorage.getItem('currency')
      const language = localStorage.getItem('language')
      const user = localStorage.getItem('user')

      if (cart) state.cart = JSON.parse(cart)
      if (currency) state.currency = currency
      if (language) state.language = language
      if (user) state.user = JSON.parse(user)
    }
  },
  actions: {
    initializeStore({ commit }) {
      commit('initializeStore')
    },
    addProductToCart({ commit }, product) {
      commit('addToCart', product)
    },
    removeProductFromCart({ commit }, productId) {
      commit('removeFromCart', productId)
    },
    updateCartItemQuantity({ commit }, payload) {
      commit('updateCartItemQuantity', payload)
    },
    clearCart({ commit }) {
      commit('clearCart')
    },
    updateCurrency({ commit }, currency) {
      commit('setCurrency', currency)
    },
    updateLanguage({ commit }, language) {
      commit('setLanguage', language)
    },
    async login({ commit }, credentials) {
      try {
        const user = { id: 1, name: 'Test User' }
        commit('setUser', user)
        return user
      } catch (error) {
        throw error
      }
    },
    async logout({ commit }) {
      commit('setUser', null)
    }
  },
  getters: {
    cartTotal: state => {
      return state.cart.reduce((total, item) => total + item.price * item.quantity, 0)
    },
    cartItemCount: state => {
      return state.cart.reduce((count, item) => count + item.quantity, 0)
    },
    isAuthenticated: state => {
      return !!state.user
    }
  },
  modules: {
    product
  }
}) 